import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { appActions } from 'src/store/app'
import { getAuthToken, getImpersonationToken } from '../../utils'
function RequireAuth({ children }) {
  const location = useLocation()
  const dispatch = useDispatch()
  const tokenLocal = getImpersonationToken() || getAuthToken()
  useEffect(() => {
    dispatch(appActions.digestValueHandler(location?.pathname?.split('/')[2]))
  }, [])

  if (tokenLocal) {
    return <Outlet />
  }

  if (!tokenLocal && location?.pathname?.split('/')[1] === 'reset-password') {
    return <Navigate to="/reset-password" />
  }

  if (!tokenLocal) {
    return <Navigate to="/login" replace />
  }
}

RequireAuth.propTypes = {
  children: PropTypes.any,
}

export default RequireAuth
